import { cn } from '@herit-fe/heritage-ui';
import type { MarketItem } from '@/shared/data-types';
import { marketDeltaText, marketDeltaTone, marketPriceText } from '@/shared/lib';
import { UI_TEXT } from '@/shared/languages';
import { ElevatedCard } from './elevated-card';

/**
 * 시장가 카드 — SMP·REC 를 한 줄에 나란히, 각 항목 `[라벨][현재가][전일대비]`. `flex-wrap` — 폭이 좁아 둘이
 * 안 들어가면 REC 가 아래 줄로 떨어짐(오버플로 방지). 2건 미만이면 미표기(구앱 정합, `buildMarketItems`).
 * 기준일은 폭 절약차 생략(`RevenueFooter` 의 `MarketFooter` 는 기준일 유지).
 *
 * 대시보드(전체)와 수익분석이 **동일 모양**을 쓰도록 shared 로 올린 SSOT(위젯끼리는 동일 레이어라 직접 공유 불가).
 */
export function MarketCard({ items }: { items: MarketItem[] }) {
  if (items.length === 0) return null;
  return (
    <ElevatedCard className="p-4">
      <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-1">
        {items.map((item) => {
          const label =
            item.kind === 'smp' ? UI_TEXT.REVENUE_MARKET_SMP : UI_TEXT.REVENUE_MARKET_REC;
          return (
            <div key={item.kind} className="flex items-center gap-2 text-sm tabular-nums">
              <span className="text-muted-foreground">{label}</span>
              <span className="font-semibold text-foreground">{marketPriceText(item)}</span>
              <span className={cn('text-xs', marketDeltaTone(item.delta))}>
                {marketDeltaText(item)}
              </span>
            </div>
          );
        })}
      </div>
    </ElevatedCard>
  );
}
